import { STATUS_LABEL, STATUS_TONE } from "@/lib/constants";

export default function StatusBadge({ status, className = "" }) {
  const tone = STATUS_TONE[status] || "slate";
  const label = STATUS_LABEL[status] || status;

  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`md-status-badge md-status-${tone} ${className}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {label}
    </span>
  );
}
